// export const clientId = import.meta.env.VITE_CLIENT_ID;
// export const redirectUri = import.meta.env.VITE_REDIRECT_URI ?? 'http://localhost:5000';
// export const fixed = import.meta.env.VITE_API_URL ?? 'http://localhost:3001/api/';
// export const publicURL = 'https://storage.googleapis.com/abi-ghq-01190-cybersecurity.appspot.com/assets/public/';
// export const getImage = 'https://storage.googleapis.com/abi-ghq-01190-cybersecurity.appspot.com/assets/';
// export const oldAssets = 'https://storage.googleapis.com/abi-ghq-01190-cybersecurity.appspot.com/public/storage/';
// export const gameUrl = 'https://storage.googleapis.com/abi-ghq-cybersecurity-prd-gcs/public/storage/cyber-games/';
// export const DataProtectionURL = 'https://storage.googleapis.com/abi-ghq-cybersecurity-web-training/';
// export const localAssets = '../images_public/';
// export const downloadPDF = 'http://localhost:3001/';
// export const gispVideos = "https://storage.googleapis.com/abi-ghq-cybersecurity-prd-gcs/public/storage/cyber-security/videos/GISP Video/";
// export const donloadDoc = 'https://storage.googleapis.com/abi-ghq-cybersecurity-prd-gcs/public/storage/meme-document/'
// export const downloadPhisingDoc = 'https://storage.googleapis.com/abi-ghq-cybersecurity-prd-gcs/public'
// export const localImages = "https://storage.googleapis.com/abi-ghq-01190-cybersecurity.appspot.com/local_assets/images/";
// export const localVideos = "https://storage.googleapis.com/abi-ghq-01190-cybersecurity.appspot.com/local_assets/videos";
// export const SecurityTraining ="https://storage.googleapis.com/abi-ghq-01190-cybersecurity.appspot.com/local_assets/SecurityTraining"
// // export const ApplicationSecurity ="abi-ghq-01190-cybersecurity.appspot.com/local_assets/ApplicationSecurity"
// export const ApplicationSecurity ="https://storage.googleapis.com/abi-ghq-01190-cybersecurity.appspot.com/local_assets/ApplicationSecurity"
// export const getWebinar = 'https://storage.googleapis.com/abi-ghq-cybersecurity-prd-gcs/public/storage/webinar/';
// export const FifaPoster='https://storage.googleapis.com/abi-ghq-01190-cybersecurity.appspot.com/public/storage/fifa-posters/'
// export const BrewstarsTraining ="https://storage.googleapis.com/abi-ghq-01190-cybersecurity.appspot.com/local_assets/"

export const clientId = import.meta.env.VITE_CLIENT_ID;
export const redirectUri = import.meta.env.VITE_REDIRECT_URI ?? 'http://localhost:5000';
export const fixed = import.meta.env.VITE_API_URL ?? 'http://localhost:3001/api/';

export const publicURL = `${fixed}email/gcpbucketfiles/assets/public/`;
export const oldAssets = `${fixed}email/gcpbucketfiles/public/storage/`;

export const gameUrl = `${fixed}email/games/public/storage/cyber-games/`;
export const DataProtectionURL = 'https://storage.googleapis.com/abi-ghq-cybersecurity-web-training/';

export const localAssets = '../images_public/';
export const downloadPDF = 'http://localhost:3001/';

export const gispVideos = `${fixed}email/games/public/storage/cyber-security/videos/GISP Video/`;
export const donloadDoc = `${fixed}email/games/public/storage/meme-document/`;
export const downloadPhisingDoc = 'https://storage.googleapis.com/abi-ghq-cybersecurity-prd-gcs/public';

export const localImages = `${fixed}email/gcpbucketfiles/local_assets/images/`;
export const localVideos = `${fixed}email/gcpbucketfiles/local_assets/videos`;
export const SecurityTraining = `${fixed}email/gcptraining/local_assets/SecurityTraining`;
export const ApplicationSecurity = `${fixed}email/gcptraining/local_assets/ApplicationSecurity`;

export const getWebinar = `${fixed}email/games/public/storage/webinar/`;
export const FifaPoster = `${fixed}email/assets/public/storage/fifa-posters/`;
export const BrewstarsTraining = `${fixed}email/gcptraining/local_assets/`;
export const getImage = `${fixed}email/gcpbucketfiles/assets/`;
export const arrowimage = `${fixed}email/games/public/storage/`;
export const getWebinar2026 =`${fixed}email/gcpfiles/local_assets/videos/`;
export const PhishingTraining = `${fixed}email/gcpfiles/local_assets/`;